import { ApiService } from '../abstract/api-service.abstract';
import { inject, Injectable } from '@angular/core';
import { LangService } from './lang.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { AnnouncementModel } from '../models/announcement.models';

export interface AnnouncementListDto {
  title?: string;
  createdAfter?: string;
  createdBefore?: string;
  skip?: number;
  take?: number;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementService extends ApiService {
  private langService: LangService = inject(LangService);

  getAnnouncementList(
    params: AnnouncementListDto = {},
  ): Observable<{ count: number; data: AnnouncementModel[] }> {
    let httpParams = new HttpParams();

    if (params.title) {
      httpParams = httpParams.set('title', params.title);
    }
    if (params.createdAfter) {
      httpParams = httpParams.set('createdAfter', params.createdAfter);
    }
    if (params.createdBefore) {
      httpParams = httpParams.set('createdBefore', params.createdBefore);
    }
    if (params.skip !== undefined) {
      httpParams = httpParams.set('skip', params.skip.toString());
    }
    if (params.take !== undefined) {
      httpParams = httpParams.set('take', params.take.toString());
    }
    if (params.orderBy) {
      httpParams = httpParams.set('orderBy', params.orderBy);
    }
    if (params.orderDirection) {
      httpParams = httpParams.set('orderDirection', params.orderDirection);
    }

    const url = `${this.apiFrontUrl}/announcement/list?date=${this.cacheUid()}`;

    return this.http
      .get<{ count: number; data: any[] }>(url, { params: httpParams })
      .pipe(
        map((data) => ({
          count: data.count,
          data: data.data.map((item) => AnnouncementModel.fromJson(item)),
        })),
      );
  }

  getAnnouncementByAlias(alias: string): Observable<AnnouncementModel> {
    return this.http.get<AnnouncementModel>(
      `${this.apiFrontUrl}/announcement/${alias}?date=${this.cacheUid()}`,
    );
  }

  getTopAnnouncement(id: string): Observable<AnnouncementModel[]> {
    return this.http.get<AnnouncementModel[]>(
      `${this.apiFrontUrl}/announcement/top?date=${this.cacheUid()}`,
      { params: { id } },
    );
  }

  createSupport(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiFrontUrl}/support`, formData);
  }
}
